import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58a36d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "house-rent-apply-detail-wrapper" }
const _hoisted_2 = { class: "house-rent-detail" }
const _hoisted_3 = {
  class: "item text-overflow",
  style: {"display":"flex"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666","margin-bottom":"0px"} }, "地址：", -1))
const _hoisted_5 = { style: {"flex":"1","margin-bottom":"0px"} }
const _hoisted_6 = {
  class: "item text-overflow",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666","margin-bottom":"0px"} }, "工商注册地址：", -1))
const _hoisted_8 = { style: {"flex":"1","margin-bottom":"0px"} }
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "租金(含物业费)：", -1))
const _hoisted_11 = { style: {"margin-right":"5px"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "押金：", -1))
const _hoisted_15 = { style: {"margin-right":"5px"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "item text-overflow" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "面积：", -1))
const _hoisted_19 = { style: {"margin-right":"5px"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "item text-overflow" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "可容纳人数：", -1))
const _hoisted_23 = { style: {"margin-right":"5px"} }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 租赁起止时间：", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "item text-overflow" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "租赁期限：", -1))
const _hoisted_30 = { class: "item text-overflow" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "房东联系方式：", -1))
const _hoisted_32 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "是否入驻产业园：", -1))
const _hoisted_34 = { class: "item text-overflow" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "打款方式：", -1))
const _hoisted_36 = { class: "item text-overflow" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "打款账号：", -1))
const _hoisted_38 = { class: "item text-overflow" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "违约金：", -1))
const _hoisted_40 = { style: {"margin-right":"5px"} }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  class: "item text-overflow",
  style: {"width":"100%","white-space":"normal"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "违约金条款：", -1))

import { ref, reactive, onMounted, withDefaults } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        Address: "",
        BusinessRegistrationAddress: "",
        Deposit: "",
        Rent: "",
        Area: "",
        CapacityNumber: "",
        LeaseStartDate: "",
        LeaseEndDate: "",
        LeaseTerm: "",
        LandlordContact: "",
        PaymentAccount: "",
        PaymentWayText: "",
        IsSettleIndustrialPark: undefined,
        Penalty: "",
        PenaltyClause: "",
      };
    } }
  },
  setup(__props: any) {

const props = __props as { detail: {
      Address: string;
      BusinessRegistrationAddress: string;
      Deposit: string;
      Rent: string;
      Area: string;
      CapacityNumber: string;
      LeaseStartDate: string;
      LeaseEndDate: string;
      LeaseTerm: number;
      LandlordContact: string;
      PaymentAccount: string;
      PaymentWayText: string;
      IsSettleIndustrialPark: string;
      Penalty: string;
      PenaltyClause: string;
    } }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.detail.Address), 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(props.detail.BusinessRegistrationAddress), 1)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(props.detail.Rent), 1),
        (props.detail.Rent)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "元"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(props.detail.Deposit), 1),
        (props.detail.Deposit)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "元"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, _toDisplayString(props.detail.Area), 1),
        (props.detail.Area)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "平方米"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", _hoisted_23, _toDisplayString(props.detail.CapacityNumber), 1),
        (props.detail.CapacityNumber)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "人"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_25, [
        _hoisted_26,
        (props.detail.LeaseStartDate && props.detail.LeaseEndDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(props.detail.LeaseStartDate) + "-" + _toDisplayString(props.detail.LeaseEndDate), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("span", null, _toDisplayString(props.detail.LeaseTerm), 1)
      ]),
      _createElementVNode("span", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("span", null, _toDisplayString(props.detail.LandlordContact), 1)
      ]),
      _createElementVNode("span", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("span", null, _toDisplayString(props.detail.IsSettleIndustrialPark == 1
            ? "是"
            : props.detail.IsSettleIndustrialPark == 2
            ? "否"
            : ""), 1)
      ]),
      _createElementVNode("span", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("span", null, _toDisplayString(props.detail.PaymentWayText), 1)
      ]),
      _createElementVNode("span", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("span", null, _toDisplayString(props.detail.PaymentAccount), 1)
      ]),
      _createElementVNode("span", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("span", _hoisted_40, _toDisplayString(props.detail.Penalty), 1),
        (props.detail.Penalty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "元"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("span", null, _toDisplayString(props.detail.PenaltyClause), 1)
      ])
    ])
  ]))
}
}

})